module.exports = __webpack_public_path__ + "865029856f294e6870c61aa9e2ff0843.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/school/Classroom2.jpg
// module id = 3385
// module chunks = 0